import { newE2EPage } from "@stencil/core/testing";
import { testValidHtml } from "../../../test-utils/html-validate";

describe("notification-item", () => {
    it("should render a component", async () => {
        const page = await newE2EPage();
        await page.setContent(`<ux-notification-item></ux-notification-item>`);
        const el = await page.find("ux-notification-item");
        expect(el).toHaveClass("hydrated");
    });

    it("should match to snapshot", async () => {
        const page = await newE2EPage();
        await page.setContent(`<ux-notification-item created-at='1661860521'></ux-notification-item>`);
        const el = await page.find("ux-notification-item.hydrated");
        await page.waitForChanges();
        expect(el).toMatchSnapshot();
    });

    it("should render valid html", async () => {
        await testValidHtml(`<ux-notification-item></ux-notification-item>`);
    });

    it("should render cropped with gradient if content is too long", async () => {
        const page = await newE2EPage();
        const longText =
            "Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et " +
            "dolore magna aliquyam erat, sed diam voluptua. At vero eos et accusam et justo duo dolores et ea rebum. Stet " +
            "clita kasd gubergren, no sea takimata sanctus est Lorem ipsum dolor sit amet. Lorem ipsum dolor sit amet," +
            " consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat, " +
            "sed diam voluptua. At vero eos et accusam et justo duo dolores et ea rebum. Stet clita kasd gubergren, no sea" +
            " takimata sanctus est Lorem ipsum dolor sit amet. Lorem ipsum dolor sit amet, consetetur sadipscing elitr," +
            " sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat, sed diam voluptua. At vero eos et " +
            "accusam et justo duo dolores et ea rebum. Stet clita kasd gubergren, no sea takimata sanctus est Lorem ipsum dolor" +
            " sit" +
            " amet.";
        await page.setContent(
            `<ux-notification-item
                    created-at='1661860521'
                    headline='Headline ${longText}'
                  ><span slot='message'>Message ${longText}</span></ux-notification-item>`
        );
        const el = await page.find("ux-notification-item.hydrated");
        await page.waitForChanges();
        const wrapper = await el.find(".ux-notification-text__wrapper");
        expect(wrapper).toHaveClass("ux-notification-text__wrapper_gradient");
        expect(wrapper).not.toHaveClass("ux-notification-text__wrapper_expanded");
    });

    it("should render a notification deletion time", async () => {
        const page = await newE2EPage();
        await page.setContent(
            `<ux-notification-item
                    created-at='1661860521'
                    headline='Headline'
                    will-delete-in="1d"
                    will-delete-in-tooltip="This notification will be deleted soon"
                  ><span slot='message'>Message</span></ux-notification-item>`
        );
        const el = await page.find("ux-notification-item.hydrated");
        await page.waitForChanges();
        const div = await el.find(".ux-notification-item__will-delete-in");
        expect(div.textContent).toContain("1d");
        expect(div.textContent).toContain("This notification will be deleted soon");
    });
});
